import React from 'react'
import { Controller } from 'react-hook-form'
import { DateRangePicker } from 'app/components/atoms'
import { useTranslation } from 'app/i18n/client'
import { Control } from 'react-hook-form'
import { DateRangePickerProps } from 'app/components/atoms/DateRangePicker'

interface FormDateRangePickerProps extends DateRangePickerProps {
  control?: Control<any>
  name: string
  defaultValue?: (Date | null)[]
  error?: any
  controllerProps?: any
}

const FormDateRangePicker = ({
  controllerProps,
  control,
  name,
  defaultValue,
  error,
  ...rest
}: FormDateRangePickerProps) => {
  const { t } = useTranslation()

  return (
    <Controller
      control={control}
      render={({ field: { onChange, value } }) => (
        <DateRangePicker
          {...rest}
          value={value}
          onChange={onChange}
          isError={!!error}
          errorMessage={t(error?.message)}
        />
      )}
      name={name}
      defaultValue={defaultValue}
      {...controllerProps}
    />
  )
}

export default FormDateRangePicker
